module.exports = __webpack_public_path__ + "img/step46.28dc8d9e.png";